import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var getViewContext = function getViewContext(_ref) {
  var _resolverContext$exte, _extension$userAccess;
  var resolverContext = _ref.resolverContext,
    accountId = _ref.accountId,
    extension = _ref.extension,
    timezone = _ref.timezone,
    locale = _ref.locale,
    extensionPayload = _ref.extensionPayload,
    extensionViewData = _ref.extensionViewData,
    theme = _ref.theme,
    surfaceColor = _ref.surfaceColor;
  // Combine the static macro extension data with the dynamic extension view data (macro body) into a single macro object
  var macro = _objectSpread(_objectSpread({}, (_resolverContext$exte = resolverContext.extension) === null || _resolverContext$exte === void 0 ? void 0 : _resolverContext$exte.macro), extensionViewData === null || extensionViewData === void 0 ? void 0 : extensionViewData.macro);

  /* adding hasAccess separately instead of using userAccess as a whole is to avoid appending __typename in the context */
  var userAccess = (_extension$userAccess = extension.userAccess) !== null && _extension$userAccess !== void 0 ? _extension$userAccess : {
    enabled: false,
    hasAccess: false
  };
  return _objectSpread(_objectSpread({}, resolverContext), {}, {
    extension: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, resolverContext.extension), extensionViewData), extensionPayload), Object.keys(macro).length > 0 ? {
      macro: macro
    } : {}),
    accountId: accountId,
    license: (extension === null || extension === void 0 ? void 0 : extension.license) || null,
    timezone: timezone,
    locale: locale,
    theme: theme,
    surfaceColor: surfaceColor,
    userAccess: userAccess
  });
};